import { FC } from 'react';

import { MagritteBannerTitle } from 'components/common/MagritteBannerTitle/MagritteBannerTitle';

import {
    QuickCampaignFieldName,
    selectQuickCampaignFormDataField,
    selectQuickCampaignFormErrors,
    setQuickCampaignFieldByName,
} from 'store/models/createQuickCampaign';
import { useDispatch, useSelector } from 'store/utils';

export const BannerTitle: FC = () => {
    const value = useSelector(selectQuickCampaignFormDataField[QuickCampaignFieldName.Title]);
    const error = useSelector(selectQuickCampaignFormErrors[QuickCampaignFieldName.Title]);

    const dispatch = useDispatch();

    const onChange = (value: string) =>
        dispatch(setQuickCampaignFieldByName({ fieldName: QuickCampaignFieldName.Title, value }));

    return <MagritteBannerTitle value={value} error={error} onChange={onChange} dataQa="ad-quick-create-title" />;
};
